import { ArrowRightIcon } from '@/components/icons/svg-icons';
import { useTranslations } from 'next-intl';
import { usePlayerSurveyIsSubmitted } from '@/hooks/query/use-player-survey';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';
import { isDesktop } from 'react-device-detect';
import './survey-entrance.scss';

export const SurveyEntrance = () => {
	const t = useTranslations('General');
	const { isSubmitted } = usePlayerSurveyIsSubmitted();

	const openSurveyForm = () => {
		// 202405 已棄用 GalaxyV1, 若欲重開此功能請重新設計埋點
		// const kafkaData = {
		// 	type: 10,
		// 	action: isDesktop ? 4 : 1, 
		// }
		// setKafkaNormal(kafkaData);
		document.dispatchEvent(new CustomEvent('show-player-survey-form', {}));
	}

	return isSubmitted === false ? (
		<div className="survey-entrance" 
			onClick={openSurveyForm}
		>
			<div className="survey-entrance__text">{t('lbl_GSabaSurveyTitle')}</div>
			<ArrowRightIcon />
		</div>
	) : null;
};